
<!-- 전체 지도 표시 -->
<div *ngIf="selectedRegion === REGION.ALL"
     [@fadeInOut]>
  <img src="assets/img/img_all_map.png"
       style="width: 100%; height: 100%"
       usemap="#region">
  <map id="region" name="region">
    <area *ngFor="let regionInfo of zoomResionList"
          alt="{{ regionInfo.name }}"
          title="{{ regionInfo.name }}"
          shape="poly"
          coords="{{ regionInfo.coords ?? '' }}"
          style="cursor: pointer;"
          (click)="onZoomRegion($event, regionInfo.region)">
  </map>

  <a *ngFor="let regionInfo of zoomResionList"
     class="map-item-label type-{{ regionInfo.css }}"
     (click)="onZoomRegion($event, regionInfo.region)"
     [innerHTML]="regionInfo.name | keepHtml">
    <i *ngIf="regionInfo.region === REGION.ALL"
       class="ic ic-place"></i>
  </a>
  <span class="map-item-label type-gyeonggi inactive"
        aria-disabled="true"
        [attr.aria-label]="inactiveRegionLabel.ariaLabel">{{ inactiveRegionLabel.name }}</span>
  <a class="map-item-box region type-0"
     (click)="onGotoDialistList($event, REGION2_DEFAULT)">
    <span class="txt">전<span class="hanja-size">全</span> 지역 우리말 모음</span>
  </a>
</div>

<!-- 줌인 지도 표시 -->
<div *ngIf="selectedRegion !== REGION.ALL"
     [@fadeInOut]>
  <div class="zoom-map type-{{ selectedRegion }}"></div>

  <!-- 해당 REGION에 속한 REGION2를 지도에 표시한다 -->
  <a *ngFor="let region2 of getRegion2InfoList()"
     class="map-item-box region region-{{ region2.cssPos }} {{ region2.region2 === REGION2_DEFAULT ? '' : 'off'}}"
     (click)="onGotoDialistList($event, region2.region2)">{{ region2.region2 !== REGION2_DEFAULT ? region2.name : ''}}
    <i *ngIf="region2.region2 === REGION2_DEFAULT"
       class="ic ic-place"></i>
    <span *ngIf="region2.region2 === REGION2_DEFAULT"
          class="txt">전<span class="hanja-size">全</span> 지역 우리말 모음</span>
  </a>

  <!-- 해당 REGION에 속한 CITY2를 지도에 표시한다 -->
  <a *ngFor="let info of getCity2InfoList()"
     class="map-item-box type-{{ info.css }} city-{{ info.cssPos }} {{ city === info.city2 || info.city2 === CITY2_DEFAULT ? '' : 'off' }}"
     (click)="onClickCity($event, info.city2)">
    {{ info.city2 !== CITY2_DEFAULT ? info.city2 : '' }}
    <img src="assets/img/btn_youtube.svg">
    <i *ngIf="info.city2 === CITY2_DEFAULT"
       class="ic ic-place"></i>
    <span *ngIf="info.city2 === CITY2_DEFAULT"
          class="txt">전<span class="hanja-size">全</span> 지역 우리말 모음</span>
  </a>

  <a class="map-item-box region type-0">
    <span class="txt" (click)="onZoomRegion($event, REGION.ALL)">돌아 가기</span>
  </a>
</div>
